module.exports = __webpack_public_path__ + "static/img/2.1e8117a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news17/2.png
// module id = 9U1z
// module chunks = 1